/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import { client } from "./client";

export const list = params => client.get("partners_affiliates", { params: params });
export const get = id => client.get(`partners/${id}`);
export const createAccount = params => client.post("partners", params);
export const show = id => client.get(`recharges/${id}`);
export const confirm = id => client.post(`recharge/${id}/capture`);
export const cancel = id => client.delete(`recharges/${id}`);
export const categoriesList = () => client.get("partners_list_categories");
export const summary = () => client.get("partners_summary");

// Whitelabel: planos de taxas do franqueador e comissões
export const rateProfiles = () => client.get("partners_rate_profiles");
export const rateProfile = id => client.get("partners_rate_profile", {
  params: id ? { rate_profile_id: id } : {},
});
export const saveRateProfile = payload => client.post("partners_rate_profile", payload);
export const enrollAffiliate = (accountId, rateProfileId) => client.post(
  "partners_enroll_affiliate",
  { account_id: accountId, rate_profile_id: rateProfileId },
);
export const commissions = params => client.get("partners_commissions", { params: params });
